export const clearLocalStorage = (keys) => {
  for (const key of keys) {
    localStorage.removeItem(key);
  }
};

export const getDataLocalStorage = (keys) => {
  if (Array.isArray(keys)) {
    const dataObject = {};

    for (const key of keys) {
      dataObject[key] = localStorage.getItem(key) || null;
    }

    return dataObject;
  }

  return localStorage.getItem(keys) || null;
};

export const setDataLocalStorage = (data) => {
  if (Array.isArray(data)) {
    for (const { value, key } of data) {
      localStorage.setItem(key, value);
    }
  } else {
    for (const key in data) {
      localStorage.setItem(key, data[key]);
    }
  }
};
